import { Component } from 'react';
import { P, Stack } from '@workramp/ui';
import styled from 'styled-components';
import Modal from '../common/modal';

/** @deprecated prefer `import { ConfirmModal } from '~/components/ConfirmModal';` */
class WRModalsConfirm extends Component {
  TRANSLATED_CANCEL = I18n.t('common.application.cancel');

  TRANSLATED_OK = I18n.t('common.application.ok');

  onSave = (onFinish) => {
    if (typeof this.props.onSave === 'function') {
      this.props.onSave();
    }

    // For now, let's close the modal and call onFinish synchronously to simplify the WRModals API. May revisit later.
    if (typeof onFinish === 'function') onFinish();
    this.props.onClose();
  };

  render() {
    const {
      show,
      onClose,
      cancelButtonTitle,
      saveButtonTitle,
      isDangerConfirm,
      text,
      alertTextRenderer,
      description,
      newUi,
      children,
    } = this.props;
    return (
      <Modal
        show={show}
        onSave={this.onSave}
        onClose={onClose}
        dontShowHeader
        cancelButtonTitle={cancelButtonTitle || this.TRANSLATED_CANCEL}
        saveButtonTitle={saveButtonTitle || this.TRANSLATED_OK}
        newUi={newUi}
        isDangerConfirm={isDangerConfirm}
      >
        <Stack size={2.5}>
          <div className="wr-modals-alert--text">{alertTextRenderer ? alertTextRenderer(text) : text}</div>
          {description && <StyledP>{description}</StyledP>}
        </Stack>
        {children}
      </Modal>
    );
  }
}

const StyledP = styled(P)`
  color: #8c9196;
`;

export default WRModalsConfirm;
